// extracted by mini-css-extract-plugin
export default {"linkBankAccountButton":"tMoQ4FKshLGeKoB65_Nb"};